import { cn } from "@newxsystems/shared";
import { RavioliAction } from "../RavioliAction/RavioliAction";
import { RavioliRichText } from "../RavioliRichText/RavioliRichText";
import type { IRavioliCommonContentProps } from "./RavioliCommonContent.props";

export const RavioliCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IRavioliCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex flex-col gap-4",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "inline-flex w-fit items-center gap-2 border border-primary bg-surface px-3 py-1.5 font-ravioli-body text-[0.8125rem] font-semibold leading-[1.125rem] text-primary before:block before:size-1.5 before:bg-primary",
            tone === "dark" && "border-canvas/60 bg-transparent text-canvas before:bg-canvas",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "font-ravioli-display text-[2rem] font-semibold leading-[2.125rem] tracking-[-0.015em] text-balance text-foreground [overflow-wrap:break-word] md:text-[2.5rem] md:leading-[2.625rem]",
            tone === "dark" && "text-canvas",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <RavioliRichText
          className={cn(
            tone === "dark" &&
              "text-canvas [&_a]:text-canvas [&_blockquote]:border-canvas/40 [&_blockquote]:text-canvas",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-4", centered && "justify-center")}>
          {actions.map((button, index) => (
            <RavioliAction
              action={button}
              className={tone === "dark" ? "border-canvas text-canvas" : undefined}
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

RavioliCommonContent.displayName = "Content::RavioliCommonContent";
